import { FC, FormEventHandler as FEH } from 'react';
import { useHistory, useLocation } from "react-router-dom";

import * as API from 'api';
import * as Meta from 'meta';
import { ROUTE } from 'route';
import { useAuth } from 'hooks';
import { gaEvent, isBuilding, setPhoneLogin, isPhoneLogin, isTC } from 'utils';
import { Footer, Header } from 'components';

const ERROR = {
  'phone': '中文姓名以及手機號碼已註冊完成\n請輸入相同的中文姓名以及手機號碼'
};

export const LoginOtherPage: FC = () => {
  const auth = useAuth();
  const history = useHistory();
  const location = useLocation();

  const query = new URLSearchParams(location.search);

  const handleSubmit:FEH<HTMLFormElement> = (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const isFromGet = !!formData.get;
    /** @ts-ignore */
    const name = isFromGet ? formData.get('username'): document.getElementById('username').value;
    /** @ts-ignore */
    const phone = isFromGet ? formData.get('phone'): document.getElementById('phone').value;

    if(!isTC(name)) {
      return alert('姓名請輸入中文');
    }

    if(!isPhoneLogin()) {
      if(!confirm(`確定帳號為 ${name}, 密碼為 ${phone}?`)) return;
    }

    fetch(API.extraUser(), {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({
        name,
        phone,
      })
    })
      .then(res => res.json())
      .then(ishara => {
        if(isBuilding()) return;
        if(ishara.errors) {
          return alert(ERROR.phone);
        }

        localStorage.setItem('ishara', ishara);
        auth.setIsAuth(true);

        setPhoneLogin();

        if(query.get('location')) {
          return history.replace(query.get('location'));
        }

        history.replace(ROUTE.HOME);
      });
  };

  return (
    <div className="wrapper">
      {Meta.loadCSS(['notice', 'login'])}
      {Meta.loadJS('main-0625')}
      {Meta.ga("登入頁")}
      <Header />
      <div className="main">
        <form className="login inner" onSubmit={handleSubmit}>
          <div className="page_text">使用姓名及電話進行登入</div>
          <div className="login_formbox">
            <div className="form_list">
              <label htmlFor="username">中文姓名(即帳號)<span className="red">*</span></label>
              <input type="text" name="username" id="username" required />
            </div>
            <div className="form_list">
              <label htmlFor="phone">手機號碼(即密碼)<span className="red">*</span></label>
              <input type="tel" name="phone" id="phone" minLength={10} maxLength={10} required />
            </div>
          </div>
          <div className="login5_box">
            <div className="login_btbox">
              <button onClick={gaEvent.bind(null, '登入', '一般登入')}>登入</button>
            </div>
            <div className="login5_info">
              <p>*登入後，您可以使用同帳號密碼於<br />活動網站觀看掃描紀錄</p>
            </div>
          </div>
        </form>
        <img className="login_left" src="/resources/html/images/intro/intro_left.png" />
        <img className="login_right" src="/resources/html/images/intro/intro_right.png" />
        <div className="other o8 ml"><img src="/resources/html/images/index/kv_p1.png" /></div>
        <div className="other o7 mr"><img src="/resources/html/images/index/kv_p2.png" /></div>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>

  );
};
